import { createAsyncThunk } from '@reduxjs/toolkit';

import { getEstablishmentListService } from 'services/establishment.service';

export const getEstablishmentList = createAsyncThunk(
  'establishment/list',
  async (_, thunkApi) => {
    try {
      const response = await getEstablishmentListService();

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
